import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainAppContent from "./MainAppContent";
import SpecialsPage from "./SpecialsPage";
import GalleryPage from "./GalleryPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainAppContent />} />
        <Route path="/specials" element={<SpecialsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
      </Routes>
    </Router>
  );
}

export default App;
